// extracted by mini-css-extract-plugin
export var currencyInput = "_mo-1";
export var currencySymbol = "_mo-0";